module.exports = __webpack_public_path__ + "img/bscscan.d3bd65e9.svg";